import idGeneratorDirective from './idGenerator.directive';

angular
    .module('rym.idGenerator', [])
    .directive('onClick', idGeneratorDirective)
    .directive('ngClick', idGeneratorDirective)
    .directive('uiSref', idGeneratorDirective);
